export namespace BarcodeExportConfigurationTranslations {
  export const common = {
    barcodeExportConfiguration: 'barcodeExportConfiguration',
  } as const;

  export const error = {
    barcodeExportConfigurationsUnableToLoadError: 'barcodeExportConfigurationsUnableToLoadError',
  } as const;

  export const exportConfigurations = {
    selectBarcodeExportConfiguration: 'selectBarcodeExportConfiguration',
    generateBarcode: 'generateBarcode',

    barcodeExportConfigurationCreatedSuccessfullyToast: 'barcodeExportConfigurationCreatedSuccessfullyToast',
    barcodeExportConfigurationUpdatedSuccessfullyToast: 'barcodeExportConfigurationUpdatedSuccessfullyToast',
    barcodeExportConfigurationDeletedSuccessfullyToast: 'barcodeExportConfigurationDeletedSuccessfullyToast',
    noValidBarcodeExportConfigurationsFoundToastTitle: 'noValidBarcodeExportConfigurationsFoundToastTitle',

    barcodeExportConfigurations: 'barcodeExportConfigurations',
    createBarcodeExportConfiguration: 'createBarcodeExportConfiguration',
    updateBarcodeExportConfiguration: 'updateBarcodeExportConfiguration',
  } as const;

  export const barcodeFormats = {
    code128: 'code128',
    code39: 'code39',
    qrCode: 'qrCode',
    dataMatrix: 'dataMatrix',
  } as const;
}
